// Lib
import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

// Utils
import { selectEndOfText } from '../../../utils/domUtil';

// Components
import Icon from '../../icons/Icon';
import LinkButton from '../../buttons/LinkButton';

// Constants
import { KEY_CODES } from '../../../utils/keyboard/keyConstants';

// Styles
import './SimplePasswordInput.scss';

const SimplePasswordInput = React.forwardRef(function SimplePasswordInput(props, ref) {
    const { value, onChange, disabled, hasError, onSubmit } = props;

    const [showPassword, setShowPassword] = React.useState(false);

    const onInputChange = (event) => onChange(event.target.value);

    const toggleShowPassword = () => {
        setShowPassword(!showPassword);
        requestAnimationFrame(() => selectEndOfText(ref.current));
    };

    const onKeyDown = (event) => {
        if (event.keyCode !== KEY_CODES.ENTER) return;
        onSubmit && onSubmit(event);
    };

    return (
        <div className={classNames('SimplePasswordInput', { error: hasError })}>
            <Icon name="lock" />
            <input
                ref={ref}
                type={showPassword ? 'text' : 'password'}
                className="password-input"
                disabled={disabled}
                value={value}
                onKeyDown={onKeyDown}
                onChange={onInputChange}
            />
            <LinkButton className="visibility-button" onClick={toggleShowPassword}>
                {showPassword ? 'Hide' : 'Show'}
            </LinkButton>
        </div>
    );
});

SimplePasswordInput.propTypes = {
    value: PropTypes.string,
    disabled: PropTypes.bool,
    hasError: PropTypes.bool,

    onChange: PropTypes.func,
    onSubmit: PropTypes.func,
};

export default SimplePasswordInput;
